import { makeStyles } from "@mui/styles";
import { sectionCommonStyle } from "../../shared/sections-common-style";

export const useStyles = makeStyles((theme) => ({
  ...sectionCommonStyle,
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
  },
  error: {
    color: '#d94c4c',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px'
  }
}));
